<template>
  <div>
    <v-btn color="green" class="" icon x-large @click="dialog = true"
      ><v-icon>mdi-plus-box</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Add Branch"
          icon="mdi-store"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-text-field
            outlined
            dense
            label="Branch Name"
            v-model="form.branch_name"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Branch Address"
            v-model="form.branch_address"
          ></v-text-field>
          <!-- branch contact no -->
          <v-text-field
            outlined
            dense
            label="Branch Contact No"
            v-model="form.branch_contact_no"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Branch TIN"
            v-model="form.branch_tin"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Branch Number"
            v-model="form.branch_number"
          ></v-text-field>
          <v-textarea
            outlined
            dense
            label="Delivery Information"
            v-model="form.delivery_information"
            rows="3"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="submit" :loading="loading"
            >Submit</v-btn
          >
          <v-btn @click="dialog = false"> Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text">addBranchModal.vue</p>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      loading: false,
      form: {},
    };
  },
  methods: {
    ...mapActions({
      add_branch: "branch/add_branch",
    }),
    async submit() {
      let x = await this.$confirm({
        title: "Add Branch",
        message: "Are you sure you want to add this branch?",
        color: "primary",
        icon: "mdi-help-circle-outline",
      });
      if (x) {
        this.add_branch(this.form).then(() => {
          this.$alert({
            title: "Success",
            message: "Branch successfully inserted!",
            color: "success",
            icon: "mdi-check-circle",
          });
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
